const UNITS_PRICE_LIST = {
  //getUnitPriceList
  UNITS_UNIT_PRICE_LIST: 'UNITS_UNIT_PRICE_LIST',
};

export default UNITS_PRICE_LIST;
